import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut } from '../../../common/Formatos'
import { Auth , LoadingComponent} from 'recupero-comunes'
import { configuracionFormAction8, ObtenerMarcas, obtenerVehiculos } from '../../../store/actions/encargado-cia-action'

const AntecendentesForm = () => {
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const [loading, setLoading]=useState(false)
  const { rutOrganizacion } = Auth.currentUser()
  const { antecedentesCasos, cfg_form8, casoImplicado,llaves} = data_encargado_cia
  const dispatch = useDispatch()

  useEffect(() => {   
   if(llaves)
   { 
    setLoading(true)
    let query = Buffer.from(JSON.stringify({"concepto":" 16"})).toString('base64');
    dispatch(obtenerVehiculos(query))
    .then(()=>{
      let query = Buffer.from(JSON.stringify({})).toString('base64');
    dispatch(ObtenerMarcas(query)); 
    })
    
    .then(()=>setLoading(false))
  }   

}, [dispatch]);
 
  return (
    <>
    <LoadingComponent show={loading}/>
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{backgroundColor:"#4F517A", color:"white"}} >      
          {cfg_form8 ? cfg_form8.cfg_form8['preparacartacobro-title-antecimpl'] : ""}
        </Card.Header>
        <Container>
          {cfg_form8 ? (
            <div>
              <Row>
                <Col>
                  <Form.Label
                    className='mb-0 mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-idimpl']}
                  </Form.Label>{' '}
                  <br />
                  <Form.Text className='mb-3'>
                    {casoImplicado && casoImplicado.length !== 'undefined'
                      ? formato_rut(
                          casoImplicado.casoImplicado[0]['RutInvolucrado']
                        )
                      : ""}
                  </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-nombreimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3  ' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined'
                      ? casoImplicado.casoImplicado[0]['NombreInvolucrado']
                      : ""}
                  </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-gestion']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {antecedentesCasos &&
                    antecedentesCasos.length !== 'undefined'
                      ? antecedentesCasos.antecedentesCasos[0]['TipoGestion']
                      : ""}
                  </Form.Text>
                </Col>

                <Col>
                  <Form.Label
                    className='mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-estadoimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined'
                      ? `${casoImplicado.casoImplicado[0]['EstadoImplicado']}`
                      : ""}
                  </Form.Text>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-tipovh']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined' && casoImplicado.casoImplicado[0]['TipoVehiculo'] != null
                      ? `${casoImplicado.casoImplicado[0]['TipoVehiculo']}`
                      : ""}
                  </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-patente']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined'
                      ? `${casoImplicado.casoImplicado[0]['Patente']}`
                      : ""}
                  </Form.Text>                  
                </Col>

                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-marca']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined' && casoImplicado.casoImplicado[0]['Marca'] != null
                      ? `${casoImplicado.casoImplicado[0]['Marca']}`
                      : ""}
                  </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 &&
                      cfg_form8.cfg_form8['preparacartacobro-input-descripcion']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {casoImplicado && casoImplicado.length !== 'undefined'
                      ? `${casoImplicado.casoImplicado[0]['Descripcion']}`
                      : ""}
                  </Form.Text>
                </Col>
              </Row>
             
            </div>
          ) : ""}
        </Container>
      </Card>
    </>
  )
}

export default AntecendentesForm
